import { withAdpCombine } from '../../config/context/config';
import { ImagePanel } from './components/MaterialPanel/ImagePanel/ImagePanel';
import { VideoPanel } from './components/MaterialPanel/VideoPanel/VideoPanel';
import { TransferStatus } from './components/MaterialUpload/util/videoUploadRequest';
import { SingleImageUpload } from './components/SingleImageUpload/SingleImageUpload';
import { SingleImageUploadGroup } from './components/SingleImageUploadGroup/SingleImageUploadGroup';
import { SingleVideoUpload, VideoUploadChangeStatus } from './components/SingleVideoUpload/SingleVideoUpload';
import { MultipleImageUpload } from './components/MultipleImageUpload';
export var MaterialLibrary = {
  ImagePanel: withAdpCombine(ImagePanel),
  VideoPanel: withAdpCombine(VideoPanel),
  SingleVideoUpload: withAdpCombine(SingleVideoUpload),
  SingleImageUpload: withAdpCombine(SingleImageUpload),
  SingleImageUploadGroup: withAdpCombine(SingleImageUploadGroup),
  MultipleImageUpload: withAdpCombine(MultipleImageUpload)
};
export { VideoUploadChangeStatus, TransferStatus, MultipleImageUpload };